import { defineStore } from 'pinia'
import { LoginRes } from '@jms/api'
import { AjaxAuthService, GlobalService } from '@jms/api'
// import Options from './city.json'
export const useAuthStore = defineStore('auth', {
  state: () => ({
    menu: [] as any,
    cityList: [] as any,
    token: '',
    userInfo: {} as LoginRes,
    isLoggedIn: false
  }),
  getters: {},
  actions: {
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        AjaxAuthService[params.isQuick ? 'getTokenByUuid' : 'login'](params)
          .then(async (res) => {
            if (res.code === 1) {
              this.userInfo = res.data
              this.token = res.data.token
              this.isLoggedIn = true
              const menu = await AjaxAuthService.menu_treeMenuUser({ id: res.data.id })
              const cityList = await GlobalService.basicsArea({})
              // const cityList = Options
              this.menu = menu.data.childs || []
              this.cityList = cityList.data
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        AjaxAuthService.logOut()
          .then((res) => {
            if (res.code === 1) {
              this.token = ''
            }
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
